// Module
var code = `<table class="table">
	<tr>
		<th>Service</th>
		<th>Queries</th>
	</tr>

	<tr ng-repeat="(k, v) in server_data">
		<td>{{ k }}</td>
		<td>
	        <pre ng-repeat="alter_table in v" id="alter_table_query"> - "{{ alter_table }}"</pre>
		</td>
	</tr>
</table>`;
// Exports
module.exports = code;